import { hybrid } from '@dpgradio/creative'

const appMiniPlayerOffset = hybrid.appInfo().platform == 'iOS' && !hybrid.isVersion({ ios: 300 }) ? 'mb-[3.8rem]' : ''

export default appMiniPlayerOffset
